import { useState, useContext, useRef, useEffect } from "react";
import { AppContext } from "../../Context";
import { useCookie } from "../LocalService";

const Form = () => {
  const { doLogin, checkLogin } = useContext(AppContext);
  const [chave, setChave] = useState();
  const nomeInput = useRef(null);
  let cookie = useCookie();

  useEffect(() => {
    cookie.removeAll();
  },[cookie])

  const addChave = (e, field) => {
    setChave(e.target.value);      
  };

  const submitDto = (e) => {
    e.preventDefault();
    doLogin(chave);
    e.target.reset();
    if (checkLogin())
        window.location.replace("/");
  };

  return (
    <form className="insertForm" onSubmit={submitDto}>
      <div className="row">
        <h4>Autenticação</h4>
      </div>
      <div className="row">
        <div className="input-field col s6">
          <input
            type="text"
            id="_chave"
            name="_chave"
            onChange={(e) => addChave(e, "chave")}
            autoComplete="off"
            required
          />
          <label htmlFor="_chave">Informe a sua chave</label>
        </div>
      </div>

      <input type="submit" value="Autenticar" />
    </form>
  );
};

export default Form;